import React from 'react';
import { ChevronRight } from 'lucide-react';

export default function QuickStatCard({
  label,
  value,
  footer,
  icon: Icon,
  color,
  onClick,
  loading = false,
  testId,
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className="fin-card group w-full text-left p-4 sm:p-5 flex flex-col xl:flex-row xl:items-center gap-3 xl:gap-4 relative cursor-pointer transition-transform duration-200 hover:-translate-y-0.5 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
    >
      <span
        className="w-10 h-10 xl:w-12 xl:h-12 rounded-full flex items-center justify-center text-white flex-shrink-0 shadow-sm"
        style={{ background: color }}
      >
        <Icon size={20} />
      </span>

      <span className="min-w-0 flex-1">
        <span className="block text-xs sm:text-[13px] font-semibold text-slate-500 dark:text-slate-400 tracking-tight">
          {label}
        </span>
        {loading ? (
          <span className="block h-6 w-24 mt-1 rounded-lg bg-slate-100 dark:bg-slate-800 animate-pulse" />
        ) : (
          <span
            className="block text-lg sm:text-xl font-bold tracking-tight text-slate-800 dark:text-slate-100 truncate"
            style={{ fontFamily: 'Plus Jakarta Sans, sans-serif' }}
          >
            {value}
          </span>
        )}
        {footer && (
          <span className="block text-[11px] text-slate-400 truncate mt-0.5">{footer}</span>
        )}
      </span>

      <ChevronRight
        size={16}
        className="absolute top-4 right-4 text-slate-300 group-hover:text-slate-500 dark:text-slate-600 dark:group-hover:text-slate-300 transition-colors"
      />
    </button>
  );
}
